import React from 'react';
export function FeaturesSection() {
  const features = [{
    num: '01',
    title: 'PASO A PASO SIN SUPOSICIONES',
    desc: <>
          Cada diseño viene con instrucciones tan detalladas que{' '}
          <strong className="text-text font-bold" data-id="element-39">
            es casi imposible equivocarse
          </strong>
          . Nada queda a la imaginación. Ideal si nunca cocinaste gelatinas o si
          ya tenés experiencia y querés resultados profesionales.
        </>
  }, {
    num: '02',
    title: 'INGREDIENTES BARATOS, GANANCIAS REALES',
    desc: <>
          Todas las recetas usan materiales que{' '}
          <strong className="text-text font-bold" data-id="element-40">
            conseguís en cualquier supermercado
          </strong>
          . Sabés exactamente qué comprar y en qué cantidad. Sin desperdicios.
          Sin gastos de más. Tu primera inversión se recupera con la primera
          venta.
        </>
  }, {
    num: '03',
    title: '+30 DISEÑOS ARTÍSTICOS Y 3D',
    desc: <>
          Flores tridimensionales, paisajes internos, degradés, gelatinas
          mosaico y mucho más. Diseños pensados para ser{' '}
          <strong className="text-text font-bold" data-id="element-41">
            irresistibles en fotos
          </strong>{' '}
          — los que hacen que la gente detenga el scroll y diga "¡quiero ese!".
        </>
  }];
  return <section className="bg-bg2 py-16 px-5" data-id="element-42">
      <div className="container-custom" data-id="element-43">
        <span className="section-tag" data-id="element-44">Lo que incluye</span>
        <h2 className="section-title" data-id="element-45">
          3 RAZONES POR LAS QUE
          <br data-id="element-46" />
          ESTO FUNCIONA DE VERDAD
        </h2>
        <p className="section-sub" data-id="element-47">
          No es un recetario más. Es un sistema completo de creación + venta.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-48">
          {features.map((feat, idx) => <div key={idx} className="bg-card border border-border rounded-xl p-[30px_24px] relative overflow-hidden" data-id="element-49">
              {/* Pink top border gradient */}
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-pink to-pink-light" data-id="element-50" />

              <div className="font-bebas text-[56px] text-border leading-none mb-2" data-id="element-51">
                {feat.num}
              </div>
              <h3 className="font-bebas text-[22px] text-white tracking-[0.5px] mb-2.5" data-id="element-52">
                {feat.title}
              </h3>
              <p className="text-[14px] text-muted leading-[1.6]" data-id="element-53">
                {feat.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}